import React, { useState, useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Card, CardActionArea, CardMedia } from '@material-ui/core';
import Grid from "@material-ui/core/Grid";
import SaveIcon from "@material-ui/icons/Save";
import { Delete, CloseOutlined, FlashAuto } from "@material-ui/icons/";
import { Formik, Form, yupToFormErrors } from "formik";
import * as Yup from "yup";
// import ModalFrame from "../../biztran_controls/Modal_Frame";
import Moment from "moment";
// import CreateMultipleDates from "./CreateMultipleDates"
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../../hooks/UseFetchData";
import transitions from "@material-ui/core/styles/transitions";
import { set } from "react-hook-form";
import { number } from "prop-types";
// import Loader from "../../biztran_controls/Loader";



const EditProduct = (props) => {
    const classes = useStyles();
    const [response, fetchData] = UseFetchData();
    const [IDID, SetIDID] = useState(props.IDID);
    // const [isOpen, setOpen] = useState(false);
    // const [Mode, setMode] = useState('');
    const [deleteresponse, DeleteQuotationdtlsData] = UseFetchData();
    const [Productresponse, FetchProduct] = UseFetchData();
    const [ModelCode, setModelCode] = useState("");
    const [Seq, setSeq] = useState("");
    const [Description, setDescription] = useState('');
    const [Rate, setRate] = useState();
    const [Quantity, setQuantity] = useState();
    const [DisablecloseBtn, setDisablecloseBtn] = useState(false);
    const [ImagePath, setImagePath] = useState('');
    const [Amount, setAmount] = useState(Rate * Quantity);
    const { value, onChange, ...rest } = props;
    const [cursor, setCursor] = useState(null);
    const ref = useRef(null);
    const [ProductSKUID, setProductSKUID] = useState('');
    const [StoreID, setStoreID] = useState();
    const [InQty, setInQty] = useState();



    const validationSchema = Yup.object({
        ModelCode: Yup.string().required("Required!"),
        Quantity: Yup.string().required("Required!"),
        Rate: Yup.string().required("Required!"),
    });

    const OnDelete = () => {
        debugger;
        var bodyFormData = new FormData();
        bodyFormData.append("StockID", props.StockID);
        DeleteQuotationdtlsData("StockOutward/DeleteIDDtls", bodyFormData);
    };


    useEffect(() => {
        if (deleteresponse.Response === true) {
            // alert("Data Deleted Succesfully.");
            props.setOpen(false);
            props.getByIDData()
            // setLoading(false);
        } else if (deleteresponse.Response === false) {
            alert("Failed.");
        }
    }, [deleteresponse]);

    useEffect(() => {
        const input = ref.current;
        // setLoading(false);
        if (input) input.setSelectionRange(cursor, cursor);
    }, [ref, cursor, value]);

    const handleChange = (e) => {
        // debugger;
        onChange && onChange(e);
        // setLoading(true);
    };

    const onSubmit = async () => {
        debugger
        var bodyFormData = new FormData();
        bodyFormData.append("StockID", props.StockID);
        bodyFormData.append("InventoryDocumentID", IDID);
        bodyFormData.append("SerialNumber", Seq);
        // bodyFormData.append("ProductID", "");
        bodyFormData.append("Description", Description);
        bodyFormData.append("OutQty", Quantity);
        bodyFormData.append("InQty", InQty);
        bodyFormData.append("Rate", Rate);
        bodyFormData.append("StoreID", StoreID);
        bodyFormData.append("ProductSKUID", ProductSKUID);
        bodyFormData.append("Model_Code", ModelCode);
        setDisablecloseBtn(true);
        await fetchData("StockOutward/AddProduct", bodyFormData);
    };

    useEffect(() => {
        // debugger;
        if (response.Response === true) {
            alert("Data Saved Succesfully.");
            props.setOpen(false);
            props.getByIDData()
        } else if (response.Response === false) {
            // setDisablecloseBtn(false);
            if (response.Message.includes("Already") === true) {
                alert(response.Message);
            } else {
                alert("Failed.");
                // setLoading(false);

            }
        }

    }, [response]);

    const PopulateData = () => {
        var bodyFormData = new FormData();
        debugger;
        // setLoading(true);
        bodyFormData.append("StockID", props.StockID);
        FetchProduct("StockOutward/IDDtlsByID", bodyFormData);
    };



    useEffect(() => {
        PopulateData();
    }, []);


    useEffect(() => {
        debugger;
        if (Productresponse.length > 0) {
            // setLoading(false);
            setModelCode(Productresponse[0].ModelCode);
            setSeq(Productresponse[0].SerialNumber);
            setDescription(Productresponse[0].Description);
            setQuantity(Productresponse[0].OutQty);
            setRate(Productresponse[0].Rate);
            setStoreID(Productresponse[0].StoreID);
            setProductSKUID(Productresponse[0].ProductSKUID);
            setInQty(Productresponse[0].InQty);

        }
    }, [Productresponse]);

    useEffect(() => {
        setAmount(Quantity * Rate);
    }, [Rate, Quantity]);




    return (
        <div>
            {/* {
        loading && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 10,
          }}>
            <Loader />
          </div>
        )
      } */}
            <Formik
                initialValues={{
                    ModelCode: ModelCode,
                    Seq: Seq,
                    Description: Description,
                    Rate: Rate,
                    Quantity: Quantity,
                    Amount: Amount,
                    ProductSKUID: ProductSKUID,
                    StoreID: StoreID,
                    InQty: InQty

                }}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
                enableReinitialize
            >
                {(formik) => {
                    return (
                        <Form>
                            <Grid spacing={1} container direction="row" >
                                <Grid spacing={1} item xs={8} container>
                                    <Grid item xs={6}>
                                        <BiztranControlsFormik
                                            control="input"
                                            type="text"
                                            label="Model Code"
                                            name="ModelCode"
                                            disabled
                                            onChange={(e) => setModelCode(e.target.value)}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <BiztranControlsFormik
                                            control="input"
                                            type="text"
                                            label="Seq"
                                            name="Seq"
                                            onChange={(e) => setSeq(e.target.value)}
                                        />
                                    </Grid>
                                    <Grid spacing={1} container direction="row">
                                        <Grid item xs={12}>
                                            <BiztranControlsFormik
                                                control="textarea"
                                                type="text"
                                                label="Description"
                                                name="Description"
                                                ref={ref}
                                                value={Description}
                                                onChange={(e) => {
                                                    setDescription(e.target.value)
                                                    handleChange()
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container direction="row" spacing={2} marginTop={5}>
                                        <Grid item xs={12} md={2} sm={4} lg={3} xl={2}  >
                                            <BiztranControlsFormik
                                                control="input"
                                                type="text"
                                                label="Avileble"
                                                disabled={true}
                                                name="InQty"
                                                onChange={(e) => setInQty(e.target.value)}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2} sm={4} lg={3} xl={2}  >
                                            <BiztranControlsFormik
                                                control="input"
                                                type="text"
                                                label="Quantity"
                                                name="Quantity"
                                                disabled={true}
                                                onChange={(e) => setQuantity(e.target.value)}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2} sm={4} lg={3} xl={2}  >
                                            <BiztranControlsFormik
                                                control="input"
                                                type="text"
                                                label="Rate"
                                                name="Rate"
                                                onChange={(e) =>
                                                    setRate(e.target.value)
                                                }
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2} sm={4} lg={3} xl={2}  >
                                            <BiztranControlsFormik
                                                control="input"
                                                type="text"
                                                label="Total"
                                                name="Total"
                                                value={Amount}
                                                disabled
                                                onChange={(e) => setAmount(e.target.value)}
                                            />
                                        </Grid>
                                    </Grid>
                                    {/* <Grid spacing={1} container direction="row">
                                        <Grid item xs={12}>
                                            <BiztranControlsFormik
                                                control="textarea"
                                                type="text"
                                                label="Remarks"
                                                name="Remarks"
                                                ref={ref}
                                                value={Remarks}
                                                onChange={(e) => {
                                                    setRemarks(e.target.value)
                                                    handleChange()
                                                }}
                                            />
                                        </Grid>
                                    </Grid> */}
                                </Grid>
                                <Grid item xs={4}>
                                    <Card className={classes.root}>
                                        <CardActionArea onClick={() => { window.open(ImagePath); }}>
                                            <CardMedia
                                                component="img"
                                                height="250"
                                                image={ImagePath}
                                                title="Product"
                                            />
                                        </CardActionArea>
                                    </Card>
                                </Grid>
                                {/* </Grid> */}
                            </Grid>
                            <Grid spacing={2} container direction="row">
                                <Grid item xs={12}>
                                    <div style={{ width: '100%' }}>
                                        <div style={{ display: 'flex', justifyContent: 'center', alignContent: "center" }}>
                                            <BiztranControls.Button
                                                text="Update"
                                                type="submit"
                                                startIcon={<SaveIcon />}
                                            />
                                            <BiztranControls.Button
                                                text="Delete"
                                                onClick={() => {
                                                    OnDelete();
                                                }}
                                                startIcon={<Delete />}
                                            />
                                            <BiztranControls.Button
                                                text="CLOSE"
                                                disabled={DisablecloseBtn}
                                                startIcon={<CloseOutlined />}
                                                onClick={() => { props.setOpen(false); }}
                                            />
                                        </div>
                                    </div>
                                </Grid>
                            </Grid>
                        </Form>
                    );
                }}
            </Formik>
            {/* <ModalFrame
                title="Split Into Multiple Delivery Dates"
                maxWidth="sm"
                isOpen={isOpen}
                headerAlign="center"
                setOpen={setOpen}
            >
                <CreateMultipleDates
                    // ProductID={ProductID}
                    StockID={props.StockID}
                    // ProductName={ProductName}
                    setOpen={setOpen}
                    PopulateData={PopulatesData}
                    Mode={Mode}
                />
            </ModalFrame> */}
        </div>
    );
};
const useStyles = makeStyles((theme) => ({
    headertext: {
        background: "#e6d8d8",
        color: "#3d3d3d",
        height: "2rem",
        paddingLeft: "30px",
        fontSize: "1.5rem",
        marginTop: "-16px",
        marginBottom: "10px",
        marginLeft: "-24px",
        marginRight: "-24px",
        //   borderRadius: "1rem",
    },
    root: {
        height: '100%',
        width: '100%',
        paddingTop: '7%',
        //paddingTop: '56.25%', // 16:9
    },
}));

export default EditProduct;
